import { Link } from "react-router-dom";
import { useConfig } from "../state";
import { AccountActions } from "./AccountActions";
import { Logo } from "./Logo";

const Nav = () => {
  const config = useConfig();
  return (
    <nav className="relative flex mx-auto text-dark font-semibold space-x-10">
      <Link to="/plus" className="inline-flex hover:text-yellow/90 relative TODO">
        <span>{config.site.title}</span>
        <div className="bg-light-green rounded-full flex items-center text-2xs text-green px-2 h-4 absolute -right-4 -top-2 z-10">
          <span>Plus</span>
        </div>
      </Link>
    </nav>
  );
};

const About = () => (
  <div className="items-center justify-end flex shrink h-full font-Gilroy font-normal">
    <Link to="/over" className="h-full flex items-center px-5 hover:text-yellow/90">
      Over
    </Link>
  </div>
);

// Final usage of the AccountActions component
export const Header = () => (
  <header
    className="fixed w-full h-14 flex items-center justify-between bg-white text-dark font-semibold z-50 border-b border-gray"
    style={{ zIndex: 100 }}
  >
    <div className="flex shrink justify-start ml-5">
      <Link to="/">
        <Logo />
      </Link>
    </div>
    <Nav />
    <About />
    <AccountActions />
  </header>
);
